import React from 'react';
import Input from '../../../../elements/Input/Input';

const DateCell = (props) => {
    const value = new Date(props?.defaultValue === "NAN" ? Date.now() : props.defaultValue);
    const year = value.getUTCFullYear();
    const month = (value.getMonth()+1) < 10 
    ? "0"+(value.getMonth()+1)
    : (value.getMonth()+1);
    const day = value.getDate()< 10 
    ? "0"+value.getDate() 
    : value.getDate();
    return <Input className={props.className}
    onBlur={value => props.onChange(new Date(`${value} 00:00:00`).getTime())}
    placeholder='enter a number'
    type="date" 
    defaultValue={`${year}-${month}-${day}`} />
}

export default DateCell;